import CustomRouter from "@src/components/CustomRouter";
import customHistory from "@src/lib/utils/history";
import React, { Suspense, useState } from "react";
import { Route, Routes } from "react-router-dom";
import routes from "./routes";
import NotFound from "@src/pages/NotFound";
import Splash from "@src/pages/Splash";

const Router: React.FC = () => {
  // const { isAuth } = useAppSelector((state) => state.login);

  return (
    <CustomRouter history={customHistory}>
      <Routes>
        {routes.map(({ component: Component, path }) => {
          return (
            <Route
              key={path}
              element={
                // <Suspense fallback={<Splash />}>
                <Suspense fallback={<></>}>
                  <Component />
                </Suspense>
              }
              path={path}
            />
          );
        })}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </CustomRouter>
  );
};
export default Router;
